import {
  Box,
  Button,
  CardMedia,
  Grid,
  Badge,
  IconButton,
  Pagination,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  Menu,
  TextField,
  useTheme,
  TablePagination,
  Theme,
  SxProps,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  DialogActions,
  Drawer,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import NotificationsActiveRoundedIcon from "@mui/icons-material/NotificationsActiveRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { CommonLayout, ConfirmationDialog } from '../commonComponents';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import AddIcon from '@mui/icons-material/Add';
import { useHistory } from 'react-router';
import { ChangeEvent, useEffect, useState } from 'react';
import { getAllApplications } from '../../redux-store/actions/application';
import { useDispatch, useSelector } from 'react-redux';
// import { FilterDropdown, initialFilters } from './filters';
// import { Distributor, getDistributorsListForFilters } from '../../redux-store/actions';
import { ApplicationFilterType, GetNotificationsResponseBody, notificationBody, ReportsListObj, ReportsListRes } from '../../redux-store/types/api-types';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { RootStateType } from '../../redux-store/reducers';
import React from 'react';
import { GetAllApplicantionsResponseBody } from '../../redux-store/types/application';
import { useDebounce } from '../../utils/useDebounce';
import DashboardAndApplicationsList from '../dashboard/applicationslist';
import { Formik } from 'formik';
import MFCheckbox from '../../lib/formik/Checkbox';
import { FilterIcon, PlusIcon, SearchIcon } from '../../assets/SvgIcons';
import { Filter, InfoOutlined } from '@mui/icons-material';
import { NOTIFICATIONS_CATEGORY, USER_ROLES } from '../../utils/constant';
import { whiteSpaceOnlyRegex } from '../../utils/regex';
import { FilterDropdown, initialFilters } from '../investors/filters';
import { ColumnType, DataTable } from '../DataTable';
import { getNotifications } from '../../redux-store/actions/notifications';
import { AmcFilter, notificationFilter, StatusFilter } from '../../redux-store/types/investorProfile';
import CustomFilter from '../investorOverview/common/CustomFilter';
import CustomNotificationFilter from '../investorOverview/common/CutomNotificationFilter';
import { getReportsInvestorList } from '../../redux-store/actions/reports';
import { getNotificationCategory } from '../../utils/utilityFunctions';
import dayjs from '../../utils/date';

interface Values {
  pan: string;
}

interface FilterProps {
  filters: ApplicationFilterType,
  open: boolean,
  handleFiltersAnchorEl: () => void,
  filtersAnchorEl: boolean,
  setPage: React.Dispatch<React.SetStateAction<number>>,
  setFilters: React.Dispatch<React.SetStateAction<ApplicationFilterType>>
  handleFiltersAnchorElClose: () => void,
  distributorLoading: boolean,
  totalFilters?: number,
  setTotalFilters?: React.Dispatch<React.SetStateAction<number>>
}


export default function Notifications(): JSX.Element {
  const history = useHistory();
  const { palette } = useTheme()
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [applicationsList, setApplicationsList] = useState<notificationBody[]>([]);
  const [noOfPages, setNoPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0)
  const [limit, setLimit] = useState(10);
  const {
    // page,
    search: storeSearch,
    status: storeStatus,
    applicationType: storeApplicationType,
    modeOfHolding: storeModeOfHolding,
    distributorId: storeDistributorId,
    diy: storeDIY,
    accountType: storeAccountType,
    onboardingType: storeOnboardingType,
    bseClientActivationStatus: storeBseStatus,
    applicationSentBack,
  } = useSelector((store: RootStateType) => store.paramsObj);
  const [currentPage, setPage] = useState(1);
  const [open, setOpen] = useState(false);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [filtersAnchorEl, setFiltersAnchorEl] = useState<boolean>(false);
  // const [distributors, setDistributors] = useState<Distributor[]>([]);
  const [filters, setFilters] = useState<ApplicationFilterType>(
    initialFilters(
      role,
      applicationSentBack ? storeStatus.replace('draft', 'draft_send_back') : storeStatus,
      storeApplicationType,
      storeModeOfHolding,
      storeDistributorId,
      storeDIY,
      storeAccountType,
      storeBseStatus,
      storeOnboardingType
    )
  );
  const { applicationType, distributorId, status, modeOfHolding, diy, accountType, onboardingType, bseClientActivationStatus } = filters;
  const [search, setSearch] = useState(storeSearch);
  const debounceSearchString = useDebounce(search, 500);
  const [distributorLoading, setDistributorLoading] = useState(false);
  const [totalFilters, setTotalFilters] = useState<number>(0);
  const theme = useTheme();
  const [isFilterDrawerOpen, setFilterDrawerOpen] = useState<boolean>(false);
  const [investorFilterData, setInvestorFilterData] = useState<notificationFilter[]>([])
  const [categoryFilterData, setCategoryFilterData] = useState<notificationFilter[]>([])
  const [isFilterLoading, setFilterLoading] = useState<boolean>(false);
  const [investorList, setInvestorList] = useState<ReportsListObj[]>([]);
  const badgeCount = ['applicationType', 'modeOfHolding', 'status', 'distributorId', 'diy', 'accountType', 'bseClientActivationStatus', 'onboardingType'].filter(
    (filterKey) => (filters[filterKey] as string[])?.length
  )?.length;

  const { iwappRmId = '', clientInterfaceCode = '', investorClientId = '' } = useSelector((store: RootStateType) => store.id);

  const getNotificationsFunc = async () => {
    setLoading(true);
    setApplicationsList([]);
    try {
      const response = await dispatch(getNotifications({
        rmId: [USER_ROLES.RM].includes(role) ? [`${iwappRmId}`] : [],
        category: categoryFilterData.filter((item: notificationFilter) => item.checked).map((item: notificationFilter) => item.id),
        clientCode: [USER_ROLES.INVESTOR].includes(role) ? [clientInterfaceCode] : investorFilterData.filter((item: notificationFilter) => item.checked).map((item: notificationFilter) => item.id),
        limit: limit,
        page: currentPage,
        sort: 'notificationTimestamp',
        order: 'DESC'
      })) as unknown as GetNotificationsResponseBody;
      // const modifiedNotifications = Object.values(response?.data).flat();
      setApplicationsList(response.data);
      setNoPages(response.pages);
      setTotalCount(response.total);
      setLimit(response.limit);
      setLoading(false);
      setPage(response.page);
    } catch (e) {
      console.error((e as Error).message);
      setLoading(false);
    }
  }

  useEffect(() => {
    getNotificationsFunc();
  }, [currentPage]);

  const handleLimitChange = async (limitValue: number) => {
    setLoading(true);
    setApplicationsList([]);
    try {
      const response = await dispatch(getNotifications({
        rmId: [USER_ROLES.RM].includes(role) ? [`${iwappRmId}`] : [],
        category: categoryFilterData.filter((item: notificationFilter) => item.checked).map((item: notificationFilter) => item.id),
        clientCode: [USER_ROLES.INVESTOR].includes(role) ? [clientInterfaceCode] : investorFilterData.filter((item: notificationFilter) => item.checked).map((item: notificationFilter) => item.id),
        limit: limitValue,
        page: 1,
        sort: 'notificationTimestamp',
        order: 'DESC'
      })) as unknown as GetNotificationsResponseBody;
      setApplicationsList(response.data);
      setNoPages(response.pages);
      setTotalCount(response.total);
      setLimit(response.limit);
      setLoading(false);
      setPage(response.page);
    } catch (e) {
      console.error((e as Error).message);
      setLoading(false);
    }
  }
  useEffect(() => {
    (async () => {
      const payload = {
        rmId: `${iwappRmId}`
      }
      const { result = [], isSuccess, message = "" } = await (dispatch(getReportsInvestorList(payload)) as unknown as Promise<ReportsListRes>)
      if (isSuccess) {
        setInvestorList(result ?? [])
        setInvestorFilterData(result.filter((item) => item.customerName !== 'ALL').map((item: ReportsListObj) => ({ id: item.clientCode, label: item.customerName, checked: false })))
      }
    })()
    setCategoryFilterData(NOTIFICATIONS_CATEGORY.map((item: notificationFilter) => ({ id: item.id, label: item.label, checked: false })))
  }, []);

  const handlePageChange = (event: ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleCloseFilterDrawer = () => {
    setFilterDrawerOpen(false)
  }

  const handleOpenFilterDrawer = () => {
    setFilterDrawerOpen(true)
  }

  const handleFilterClearAll = async () => {
    setFilterDrawerOpen(false);
    setInvestorFilterData(prevState => prevState.map(item => ({ ...item, checked: false })))
    setCategoryFilterData(prevState => prevState.map(item => ({ ...item, checked: false })))
    const response = await dispatch(getNotifications({
      rmId: [USER_ROLES.RM].includes(role) ? [`${iwappRmId}`] : [],
      category: [],
      clientCode: [USER_ROLES.INVESTOR].includes(role) ? [clientInterfaceCode] : [],
      limit: limit,
      page: 1,
      sort: 'notificationTimestamp',
      order: 'DESC'
    }) as unknown as Promise<GetNotificationsResponseBody>);
    if (response) {
      setApplicationsList(response.data);
      setNoPages(response.pages);
      setTotalCount(response.total);
      setLimit(response.limit);
      setPage(1);
      setLoading(false);
    }
  }

  const handleApplyFilters = async () => {
    setFilterDrawerOpen(false);
    if (categoryFilterData.filter((item: notificationFilter) => item.checked).length === 0 && investorFilterData.filter((item: notificationFilter) => item.checked).length === 0) return;
    const response = await dispatch(getNotifications({
      rmId: [USER_ROLES.RM].includes(role) ? [`${iwappRmId}`] : [],
      category: categoryFilterData.filter((item: notificationFilter) => item.checked).map((item: notificationFilter) => item.id),
      clientCode: [USER_ROLES.INVESTOR].includes(role) ? [clientInterfaceCode] : investorFilterData.filter((item: notificationFilter) => item.checked).map((item: notificationFilter) => item.id),
      limit: limit,
      page: 1,
      sort: 'notificationTimestamp',
      order: 'DESC'
    }) as unknown as Promise<GetNotificationsResponseBody>)

    if (response) {
      setApplicationsList(response.data);
      setNoPages(response.pages);
      setTotalCount(response.total);
      setLimit(response.limit);
      setPage(1);
      setLoading(false);
    }
  }

  const handleCategoryFilterChange = (value: string, checked: boolean) => {
    setCategoryFilterData(prevState => prevState.map(item => ({ ...item, checked: item.id === value ? checked : item.checked })))
  }
  const handleRmFilterChange = (value: string, checked: boolean) => {
    console.log(value, checked)
  }
  const handleInvestorFilterChange = (value: string, checked: boolean) => {
    setInvestorFilterData(prevState => prevState.map(item => ({ ...item, checked: item.id == value ? checked : item.checked })))
  }

  const handleInvestorSearch = (value: string) => {
    const searchValue = `${value ?? ''}`.toLowerCase();
    const filteredData = investorList.filter((item: any) => {
      const clientCode = `${item.clientCode ?? ''}`.toLowerCase();
      const customerName = `${item.customerName ?? ''}`.toLowerCase();
      return clientCode.includes(searchValue) || customerName.includes(searchValue);
    });
    setInvestorFilterData(filteredData.map((item: ReportsListObj) => ({ id: item.clientCode, label: item.customerName, checked: false })));
  }

  return (
    <CommonLayout>
      <>
        <Box>
          {/* <Box sx={{ marginBottom: '20px' }}>
            <Typography sx={{ color: 'text.primary' }} variant='h1'>Notifications</Typography>
          </Box> */}

          <Box
            sx={{
              borderRadius: '25px',
              overflow: 'hidden',
              backgroundColor: palette.background.paper,
              width: '100%',
              border: '1px solid ',
              // maxWidth: { lg: '1200px', xs: '100%' },
            }}
          >
            <Grid
              container
              sx={{
                p: { xs: '5px 15px', md: '5px 25px' },
                pb: 0,
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                bgcolor: 'common.white',
                flexDirection: 'row-reverse',
                borderBottom: `1px solid ${theme.palette.text.secondary}B2`,
                // mb: 1.5,
              }}>
              <Grid item container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, pb: 1 }}>
                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: '25px', flexDirection: 'row' }}>
                  <Typography sx={{ color: 'text.primary' }} variant='h2'>Notifications</Typography>
                </Grid>
                <Grid item sx={{ display: 'flex', alignItems: 'center', gap: '25px', flexDirection: 'row' }}>
                  <Button
                    variant="text"
                    startIcon={
                      <FilterIcon
                        style={{ opacity: (isFilterLoading) ? 0.5 : 1 }}
                      />
                    }
                    sx={(theme: Theme) => ({
                      color: theme.palette.text.primary,
                      padding: "5px",
                      ...theme.typography.body_500,
                      "&:hover": {
                        backgroundColor: theme.palette.grey[50]
                      }
                    })}
                    TouchRippleProps={{
                      style: {
                        color: theme.palette.grey[300]
                      }
                    }}
                    onClick={handleOpenFilterDrawer}
                    disabled={isFilterLoading}
                  >
                    Filters
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            <Box sx={{
              width: '100%',
              overflowX: 'auto'
            }}>
              <NotificationsList
                isLoading={isLoading}
                applicationsList={applicationsList ?? []}
                boxStyles={{ minWidth: 100 }}
              />

            </Box>
            {!!applicationsList?.length && (
              <TablePagination
                style={{
                  color: palette.text.primary[500],
                  fontSize: 16,
                  fontWeight: 500,
                  padding: '20px 35px 35px 35px',
                  // paddingLeft: '50px',
                  // paddingBottom: '48px'
                }}
                rowsPerPageOptions={[5, 10, 25, 50]}
                labelRowsPerPage="Rows per page:"
                component="div"
                count={totalCount}
                rowsPerPage={limit}
                page={currentPage - 1}
                onPageChange={(event, num) => setPage(num + 1)}
                onRowsPerPageChange={(event) => (setLimit(Number(event.target.value)), handleLimitChange(Number(event.target.value)))}
                sx={{
                  color: palette.text.primary[500]
                }} />
            )}
          </Box>
        </Box>
        <Drawer
          open={isFilterDrawerOpen}
          onClose={handleCloseFilterDrawer}
          anchor="right"
          PaperProps={{
            sx: {
              padding: "25px",
              width: "450px"
            }
          }}
          ModalProps={{
            sx: (theme: Theme) => ({
              backgroundColor: `${theme.palette.common.black}03`
            })
          }}
        >
          <CustomNotificationFilter
            isLoading={false}
            handleClearAll={handleFilterClearAll}
            handleApplyFilters={handleApplyFilters}
            showCloseIcon={true}
            handleCloseIconClick={handleCloseFilterDrawer}
            // isFilterApplied={isFilterApplied}
            showCategoryFilter
            showRmFilter={![USER_ROLES.RM, USER_ROLES.INVESTOR].includes(role)}
            showInvestorFilter={![USER_ROLES.INVESTOR].includes(role)}
            handleCategoryFilterChange={handleCategoryFilterChange}
            handleRmFilterChange={handleRmFilterChange}
            handleInvestorFilterChange={handleInvestorFilterChange}
            categoryFilterData={categoryFilterData}
            rmFilterData={[]}
            InvestorFilterData={investorFilterData}
            handleInvestorSearch={handleInvestorSearch}
          />
        </Drawer>
      </>
    </CommonLayout>
  );
}

const FilterOptions = (props: FilterProps): JSX.Element => {
  const { filters, open, handleFiltersAnchorEl, filtersAnchorEl, setPage, setFilters, handleFiltersAnchorElClose, distributorLoading, totalFilters, setTotalFilters } = props;
  const { palette } = useTheme()
  const badgeCount = ['applicationType', 'modeOfHolding', 'status', 'distributorId', 'diy', 'accountType', 'bseClientActivationStatus', 'onboardingType'].filter(
    (filterKey) => (filters[filterKey] as string[])?.length
  )?.length;
  return (
    <>
      <Box
        component={'button'}
        sx={{ display: 'flex', alignItems: 'center', gap: '10px', border: 'none', background: 'transparent', cursor: 'pointer' }} onClick={handleFiltersAnchorEl}>

        <Badge
          showZero
          badgeContent={totalFilters}
          sx={(theme: Theme) => ({
            '& .MuiBadge-badge': {
              right: 0,
              top: -3,
              backgroundColor: theme.palette.primary[500],
              color: theme.palette.common.white,
              ...theme.typography.subtitle_600
            },
          })}
        >
          <FilterIcon />
        </Badge>
        <Typography variant='body_400' sx={{ fontWeight: 500, color: palette.text.primary }}>Filters</Typography>
      </Box>
      {filtersAnchorEl && (
        <FilterDropdown
          filters={filters}
          onFiltersChange={(value) => {
            setPage(1);
            setFilters(value);
          }}
          anchorEl={filtersAnchorEl}
          handleClose={handleFiltersAnchorElClose}
          loader={distributorLoading}
          setTotalFilters={setTotalFilters}
        />

      )}
    </>
  );
};

export const formatDate = (dateStr: any) => {
  if (!dateStr || dateStr === "19700101") return "N/A";
  const date = dateStr.includes("-")
    ? new Date(dateStr)
    : new Date(
      dateStr.slice(0, 4),
      dateStr.slice(4, 6) - 1,
      dateStr.slice(6, 8)
    );
  return date.toLocaleDateString("en-IN", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatTimeStamp = (dateStr: any) => {
  const timestamp = !Number.isNaN(Number(dateStr)) ? Number(dateStr) : 0
  const dayjsObj = dayjs(timestamp)
  const notificationDate = dayjsObj.format('DD MMM, YY')
  const notificationTime = dayjsObj.format('hh:mm A')

  return `${notificationDate} (${notificationTime})`
}

export const getNotificationsTableHeader = (): ColumnType[] => {

  return [
    {
      header: 'UCC Code',
      label: 'customer',
      valueGetter: (row: notificationBody) => (
        <Typography variant='subtitle_500'>
          {row.clientCode || 'N/A'}
        </Typography>)
    },
    {
      header: 'Investor Name',
      valueGetter: (row: notificationBody) =>
        row.clientName || '-'
    },
    {
      header: 'Notifications Category',
      valueGetter: (row: notificationBody) => row.category?.replace(/_/g, " ") || 'N/A',
    },
    {
      header: 'Notifications Type',
      renderCell: (row: notificationBody) => {
        const { palette } = useTheme();

        return (
          <Box
            className={getNotificationCategory(row.notificationType)}
            sx={(theme: Theme) => ({
              '& .MuiTypography-root': {
                ...theme.typography.subtitle_500,
                color: '#B78813',
              },
              '&.ALERT .MuiTypography-root': {
                color: palette.primary[500],
              },
              '&.FATAL .MuiTypography-root': {
                color: palette.error[500],
              },
              '&.Success .MuiTypography-root': {
                color: palette.success[500],
              },
              '&.Failed .MuiTypography-root': {
                color: palette.warning[500],
              },
            })}>
            <Typography
              variant='subtitle_500'
              sx={{ textDecoration: 'none' }}>
              {getNotificationCategory(row.notificationType)}
            </Typography>
          </Box>
        );
      },
    },
    {
      header: 'Next Re-KYC Date',
      valueGetter: (row: notificationBody) => formatDate(row.nextRekycDate) || '-',
    },
    {
      header: 'Trade Restriction',
      valueGetter: (row: notificationBody) => row.tradeRestriction || '-',
    },
  ];
};

function NotificationsList({
  isLoading,
  applicationsList,
  boxStyles,
  DashboardApplicationsList,
}: {
  isLoading: boolean;
  applicationsList: notificationBody[];
  boxStyles?: SxProps<Theme>;
  DashboardApplicationsList?: boolean;
}): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const [applicationsListData, setApplicationsListData] = useState<notificationBody[]>([]);

  const [row, setRow] = useState<notificationBody>({} as notificationBody);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  useEffect(() => {
    setApplicationsListData(applicationsList);
  }, [applicationsList]);

  const theme = useTheme();

  const additionalCell = {
    header: 'Info',
    renderEditDeleteCell: (row: notificationBody): JSX.Element => {

      const handleDialogOpen = () => {
        setDialogOpen(true);
        setRow(row);
      }

      return (
        <IconButton
          onClick={handleDialogOpen}
        >
          <InfoOutlinedIcon color="info" />
        </IconButton >
      );
    },
  };

  return (
    <>
      <DataTable
        isLoading={isLoading}
        tableHeader={[...(getNotificationsTableHeader()), additionalCell]}
        tableData={applicationsListData}
        rowCustomStyles={{
          '&:last-child td, &:last-child th': { border: 0 },
          '.MuiTableCell-body ': { color: theme.palette.text.primary, fontWeight: 500 },
          background: 'transparent',
        }}
        boxStyles={boxStyles}
      />

      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: 10,
            background:
              theme.palette.mode === "light"
                ? "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)"
                : "linear-gradient(135deg, #1e1e1e 0%, #2a2a2a 100%)",
          },
        }}
      >
        {/* Title bar with close icon */}
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid",
            borderColor: "divider",
            pr: 1,
          }}
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            <NotificationsActiveRoundedIcon color="primary" />
            <Typography variant="h6" fontWeight={600}>
              Notification Details
            </Typography>
          </Box>
          <IconButton onClick={() => setDialogOpen(false)} size="small">
            <CloseRoundedIcon />
          </IconButton>
        </DialogTitle>

        {/* Main content */}
        <DialogContent sx={{ py: 3 }}>
          {/* Highlighted notification message */}
          <Box
            sx={{
              p: 2.5,
              mb: 3,
              borderRadius: 2,
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Typography
              variant="h6"
              fontWeight={600}
              color="primary.main"
              gutterBottom
            >
              {row?.notificationHeader || "No title available"}
            </Typography>
            <Typography
              variant="subtitle1"
              fontWeight={500}
              color="text.primary"
              gutterBottom
            >
              {row?.notificationSubHeader || "No message available"}
            </Typography>
            {/* <Typography variant="body2" color="text.secondary">
              Category: {row?.category?.replace(/_/g, " ")}
            </Typography> */}
            <Typography variant="body2" color="text.secondary">
              Type: {getNotificationCategory(row.notificationType)}
            </Typography>
          </Box>

          {/* Business information */}
          <Stack spacing={1}>
            <Typography variant="body1">
              <strong>Customer Name:</strong> {row?.clientName || "-"}
            </Typography>
            {/* <Typography variant="body1">
              <strong>Business Date:</strong> {formatDate(row?.businessDate)}
            </Typography> */}
            <Typography variant="body1">
              <strong>Notification Start Date:</strong> {formatTimeStamp(row?.notificationTimestamp)}
            </Typography>
          </Stack>
        </DialogContent>

        <Divider />

        {/* Action buttons */}
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button variant="contained" fullWidth onClick={() => setDialogOpen(false)}>
            OK
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
}